<template>
  <div>
    <div class="uv-card">
      <div class="uv-card-body">
        <h3 class="uv-card-title">Configuración departamentos</h3>
      </div>
    </div>
    <template v-for="(dep, index) in departments">
      <div :key="index" style="margin-top: 10px" class="uv-card">
        <div class="uv-card-body">
          <h3 class="uv-card-title">{{ dep.Nombre }}</h3>
          <div class="">
            <div class="field">
              <v-textarea
                label="Texto Ticket"
                v-model="dep.TextoTicket"
              ></v-textarea>
            </div>
            <div>
              <v-btn
                color="success"
                class="float-right"
                @click="saveTicket(dep.id, dep.TextoTicket)"
              >
                Guardar
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped></style>

<script>
export default {
  name: "configDepartamentos",
  components: {},
  data() {
    return {
      systemConf: {
        round: false,
        requestNum: false,
        iva: "",
        mxnDollar: "",
        AlertasDeRetiro: false,
        LimiteAlertaRetiro: 0,
      },
    };
  },
  computed: {
    departments() {
      return this.$store.getters.getPDVDepartamentos;
    },
  },
  methods: {
    async getData() {
      const conf = await this.$store.getters.getFirebaseApp.database
        .ref("PDV/CONF")
        .once("value");
      let resultConf = conf.val();
    },
    saveTicket(departamento, texto) {
      let datos = {
        Departamento: departamento,
        TextoTicket: texto,
      };
      this.$swal({
        title: "¿Deseas modificar la configuración del departamento?",
        text: " Los cambios se aplicaran en todo el sistema ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Departamentos-cambiarTextoCupon", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La configuración se guardo correctamente ",
              icon: "success",
            });
          } else {
            this.$swal(
              "Error Aplicando Configuración",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    saveMoneda() {
      let datos = {
        From: this.$Currencies.getCurrencyDefault(),
        To: "USD",
        Valor: parseFloat(this.systemConf.mxnDollar),
      };
      this.$swal({
        title: "¿Deseas modificar el valor del dolar?",
        text: " Los cambios se aplicaran en todo el sistema ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("Configuracion-Monedas-updateMoneda", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El valor del dolar se guardo correctamente ",
              icon: "success",
            });
          } else {
            this.$swal(
              "Error Aplicando Configuración",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
  },
  beforeMount: function () {},
  mounted: function () {
    this.getData();
  },
};
</script>
